export * from './lib/domain-payments.module';
export * from './lib';
